import React from "react";
import { HelmetProvider } from "react-helmet-async";
import { createRoot } from "react-dom/client";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import TagManager from "react-gtm-module";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_ID,
  auth: process.env.REACT_APP_GTM_ENV_AUTH,
  preview: process.env.REACT_APP_GTM_ENV_PREVIEW,
};

TagManager.initialize(tagManagerArgs);

const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Router>
        <App />
      </Router>
    </HelmetProvider>
  </React.StrictMode>
);
